import type { IQuestionDto, IQuestionResponse } from "./types";
import type { IPathBaseParam, IPathByIdParam } from "./path";

import type { IApiResponse, IPagination, IPaginationParams } from "@/api";
import { createGetAllApi } from "@api/util/createGetAllApi";
import { createPostApi } from "@api/util/createPostApi";
import { createGetApi } from "@api/util/createGetApi";
import { createDeleteApi } from "@api/util/createDeleteApi";
import { createPatchApi } from "@api/util/createPatchApi";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IQuestionResponse>>,
  IPathBaseParam,
  IPaginationParams
>("courses.exams.interactive.questions");
const postApis = createPostApi<
  IApiResponse<IQuestionResponse>,
  IPathBaseParam,
  IQuestionDto
>("courses.exams.interactive.questions");
const getApis = createGetApi<
  IApiResponse<IQuestionResponse>,
  IPathByIdParam,
  object
>("courses.exams.interactive.questions");
const patchApis = createPatchApi<
  IApiResponse<IQuestionResponse>,
  IPathByIdParam,
  IQuestionDto
>("courses.exams.interactive.questions");
const deleteApis = createDeleteApi<
  IApiResponse<IQuestionResponse>,
  IPathByIdParam
>("courses.exams.interactive.questions");

export const questions = {
  ...getAllApis,
  ...getApis,
  ...postApis,
  ...patchApis,
  ...deleteApis,
};
